/**
 * Core – Messages (legacy keys in translation namespace)
 */

export default {
  messages: {
    cancel: "Cancel",
    delete: "Delete",
    nothingFound: "Nothing found",
    tryToChange: "Try to change your filters",
  },
};
